var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c("span", { staticClass: "visually-hidden" }, [
        _vm._v(_vm._s(_vm.offerNameAccessibility)),
      ]),
      _vm._v(" "),
      _c("ob1-boutons", {
        attrs: {
          "data-bs-toggle": "modal",
          "data-bs-target": "#" + _vm.popinId,
          "is-primary": _vm.isPrimary,
          "is-secondary": !_vm.isPrimary,
          label: _vm.label,
          "data-oevent-category": _vm.trackingCategory,
          "data-oevent-action": _vm.label,
          "data-oevent-label": _vm.trackingLabel,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("all-disponibilities-popin", {
            attrs: {
              id: _vm.popinId,
              title: _vm.popinCtasDto.title,
              "tdc-section": _vm.popinCtasDto.tdcSection,
              "eresa-section": _vm.popinCtasDto.eresaSection,
              "eco-foot-note": _vm.popinCtasDto.ecoFootNote,
              "tdc-href": _vm.popinCtasDto.tdcSection.button.href,
              "eresa-href": _vm.popinCtasDto.eresaSection.button.href,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }